export default __webpack_public_path__ + "static/media/Rastech-update-9.5459b928.jpg";